import { combineReducers } from 'redux'
import UserInfoReducer from './reducers/UserInfoReducer'
import PublicConfigReducer from './reducers/PublicConfigReducer'

const Reducers= combineReducers({
  UserInfoReducer,
  PublicConfigReducer
})

export default Reducers